export enum AccessPaths {
  Content = 'content',
  Requests = 'requests',
}

export enum AccessParams {
  RequestRef = 'requestRef',
  AudioSegmentId = 'audioSegmentId',
}
